import styled from 'styled-components'

export const StyledClientInformation = styled.div`
  position: relative;
  width: 100%;
`

export const StyledEditButton = styled.sup`
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
  padding-left: 10px;
`
